import ActionCard from 'components/elections/ActionCard/ActionCard';

export default ActionCard;
